import { render, staticRenderFns } from "./ManagerRatingDetails.vue?vue&type=template&id=156617cc&scoped=true"
import script from "./ManagerRatingDetails.vue?vue&type=script&lang=js"
export * from "./ManagerRatingDetails.vue?vue&type=script&lang=js"
import style0 from "./ManagerRatingDetails.vue?vue&type=style&index=0&id=156617cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156617cc",
  null
  
)

export default component.exports